/**
 * Created by senani on 1/2/19.
 */

import React, {Component} from "react";
import "./SalesTableHeader.css";

import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../../../Site/QuotationForm/InitialQuotationState";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import NumericLabel from 'react-pretty-numbers';

const optionsInEN = [
    {text: "Today", value: 1},
    {text: "This Week", value: 2},
    {text: "This Month", value: 3},
    {text: "This Year", value: 4},
    {text: "Date Range", value: 5},
    {text: "All", value: null}
];
const optionsInJP = [
    {text: "今日", value: 1},
    {text: "今週", value: 2},
    {text: "今月", value: 3},
    {text: "今年", value: 4},
    {text: "期間", value: 5},
    {text: "全て", value: null}
];

const FromToDateToggle = (props) => {
    return (
        <div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label">
                    <FormattedMessage id="app.order.history.date.from"
                                      defaultMessage="From"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right no-padding-left-responsive">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input" max="9999-12-31"
                       name="from" type="date"/>
            </div>
            <div className="col-md-1">&nbsp;</div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label no-padding">
                    <FormattedMessage id="app.order.history.date.to"
                                      defaultMessage="To"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right no-padding-left-responsive">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input" max="9999-12-31"
                       name="to" type="date"/>
            </div>
        </div>
    )
};

class SalesTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            period: null
        };

        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    // componentDidMount() {
    //     document.getElementById("completed").click();
    //     document.getElementById("pending").click();
    //     document.getElementById("progress").click();
    // }

    handlePeriodChange = (periodChangeEvent) => {
        if (periodChangeEvent.target.name == "period-input") {
            this.setState({
                period: periodChangeEvent.target.value
            }, () => {
                if (this.state.period === "All") {
                    this.props.getAllOrders(0, 5);
                }
            });
        }
        if (periodChangeEvent.target.name == "from") {
            this.props.setSearchTimeRange("from", periodChangeEvent.target.value);
        } else if (periodChangeEvent.target.name == "to") {
            this.props.setSearchTimeRange("to", periodChangeEvent.target.value);
        } else {
            this.props.setSearchTimePeriod(periodChangeEvent.target.value);
        }
    };

    render() {
        // console.log("RENDERING....");
        let lang = InitialQuotationState.lang;
        let option = {
            'locales': 'en-AU',
            'precision': 2,
            'wholenumber': null,
            'commafy': true,
            'justification': 'L'
        };
        let ordertotal = 0;
        return (
            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-6 pull-left no-padding">
                        <div className="all-order-header-label">
                            {/*<FormattedMessage id="app.order.history.header.status"
                                              defaultMessage="Status:"
                                              description=""/>*/}
                            注文ステータス
                        </div>
                    </div>
                    <div className="col-md-6 pull-right no-padding">

                    </div>
                    <div className="col-md-6"></div>


                </div>
                <div className="row no-padding">
                    <table className="status-table-order">
                        <tbody className="admin-tr-sales">

                        {!this.props.hideOrderStatus ?
                            <tr  className="custom-col-12">
                                <td className="custom-col-3">
                                    <input name="progress" defaultChecked={true} id="progress" type="checkbox"
                                           value="IN_PRODUCTION" onChange={this.props.setSearchStatus}/>

                                </td>
                                <td className="custom-col-3  view-orders-tr-responsive">
                                    生産中
                                    {/*in production*/}
                                </td>
                                {/* <td>
                                <input name="completed" defaultChecked={true} id ="completed" type="checkbox" value="DELIVERED" onChange={this.props.setSearchStatus}/>

                            </td>
                            <td>
                                配達

                            </td>*/}
                                <td className="custom-col-3">
                                    <input name="pending" defaultChecked={true} id="pending" type="checkbox"
                                           value="PENDING" onChange={this.props.setSearchStatus}/>

                                </td>
                                <td className="custom-col-3 view-orders-tr-responsive">
                                    保留中
                                    {/*pending*/}
                                </td>
                                <td className="custom-col-3">
                                    <input name="warehouse" defaultChecked={true} id="warehouse" type="checkbox"
                                           value="IN_WAREHOUSE" onChange={this.props.setSearchStatus}/>

                                </td>
                                <td className="custom-col-3 view-orders-tr-responsive">
                                    倉庫内
                                    {/*warehouse*/}
                                </td>
                                <td className="custom-col-3">
                                    <input name="shipped" defaultChecked={true} id="shipped" type="checkbox"
                                           value="SHIPPED" onChange={this.props.setSearchStatus}/>

                                </td>
                                <td className="custom-col-3 view-orders-tr-responsive">
                                    出荷済み
                                    {/*shipped*/}
                                </td>
                            </tr>
                            :
                            <tr>
                                <td>
                                    <input name="shipped1" checked={true} defaultChecked={true} id="shipped"
                                           type="checkbox" value="SHIPPED" disabled={true}/> 出荷済み
                                    {/*shipped*/}
                                </td>
                            </tr>
                        }


                        </tbody>
                    </table>

                </div>


                <div className="row">&nbsp;</div>
                <div className="row no-padding">
                    <div className="col-md-2 no-padding left-margin">検索オプション</div>
                    <div className="col-md-2 text-left search-options-1 sales-option-padding-left">
                        <input type="radio" name="searchFlag" value="createdDate" defaultChecked={true}
                               onChange={this.props.handleSearchType}/> 注文日
                    </div>
                    <div className="col-md-2 text-left search-options-1 no-padding">
                        <input type="radio" name="searchFlag" value="shippedDate"
                               onChange={this.props.handleSearchType}/> 発送日
                    </div>
                    <div className="col-md-6">&nbsp;</div>
                </div>
                <div className="row">&nbsp;</div>
                <div className="row">

                    <div className="col-md-1 no-padding">
                        <div className="all-order-header-label">
                            <FormattedMessage id="app.order.history.header.date-period"
                                              defaultMessage="Date Period"
                                              description=""/>
                        </div>
                    </div>
                    <div className="col-md-2 no-padding-right no-padding-left-responsive">
                        <select name="period-input" onChange={this.handlePeriodChange}
                                className="form-control all-order-header-search-input">
                            {/*<option value={1}>Today</option>*/}
                            {/*<option value={2}>This Week</option>*/}
                            {/*<option value={3}>This Month</option>*/}
                            {/*<option value={4}>This Year</option>*/}
                            {/*<option value={5}>Date Range</option>*/}
                            {/*<option value={null}>All</option>*/}
                            {lang == "ja" ?
                                optionsInJP.map((optionJA) => {
                                    return <option key={optionJA.value} value={optionJA.value}>{optionJA.text}</option>
                                }) :

                                optionsInEN.map((optionEN) => {
                                    return <option key={optionEN.value} value={optionEN.value}>{optionEN.text}</option>
                                })
                            }
                        </select>
                    </div>

                    <div className="col-md-1">&nbsp;</div>
                    {this.state.period == 5 ? <FromToDateToggle
                        handlePeriodChange={this.handlePeriodChange}
                    /> : ""}
                </div>

                <br/>
                <div>
                    <div className="row">
                        <div className="col-md-4 no-padding-left sales-option-padding-left">
                            <label>件数 :
                                <span>
                                &nbsp;&nbsp;
                                    {this.props.allOrderCount}
                                    {/*{this.props.orders.length}*/}
                            </span>
                            </label>
                        </div>
                        <div className="col-md-4 text-left sales-option-padding-left">
                            <label> <FormattedMessage id="app.admin.all.order.table.all.order.total"
                                                      defaultMessage="Total of All Orders:"
                                                      description=""/>
                                <span>&nbsp;&nbsp;JPY&nbsp;
                                    {/* {this.props.orders.map(orders => {
                                    ordertotal=ordertotal+orders.orderTotal;

                                })}*/}
                                    <NumberFormatter num={this.props.totalAmount}/>
                                    {/*<NumberFormatter num = {ordertotal}/>*/}
                            </span>
                            </label></div>
                        <div className="col-md-4 text-left sales-option-padding-left">
                            <label><FormattedMessage id="app.admin.all.order.table.all.order.cost"
                                                     defaultMessage="Cost of All Orders: "
                                                     description=""/>
                                <span>
                                    &nbsp;&nbsp;USD&nbsp;
                                    <NumericLabel params={option}>{this.props.dollarAmount}</NumericLabel>
                                    {/*{this.state.allOrderCost}*/}
                            </span>
                            </label>
                        </div>

                    </div>
                </div>

                {/*<div className="row">*/}

                {/*/!*<div className="admin-table-width">*!/*/}
                {/*/!*<div className="admin-table-header-responsive admin-table-scroll">*!/*/}

                {/*<hr/>*/}
                {/*<div className="all-order-table-header">*/}
                {/*/!*<hr/>*!/*/}
                {/*/!*<div className="col-md-1">#</div>*!/*/}
                {/*<div className="col-md-2 custom-col-2">*/}
                {/*<FormattedMessage id="app.admin.all.order.table.id"*/}
                {/*defaultMessage="Order Id"*/}
                {/*description=""/>*/}
                {/*</div>*/}
                {/*<div className="col-md-2 custom-col-2 ">*/}
                {/*/!*<FormattedMessage id="app.admin.all.order.table.date"*/}
                {/*defaultMessage="Order Date"*/}
                {/*description=""/>*!/*/}

                {/*{!this.props.hideOrderStatus ?*/}
                {/*"注文日"*/}
                {/*:*/}
                {/*"発送日"*/}
                {/*}*/}

                {/*</div>*/}
                {/*/!*<div className="col-md-2 no-padding-left no-margin">*!/*/}
                {/*/!*<FormattedMessage id="app.admin.all.order.table.customer-name"*!/*/}
                {/*/!*defaultMessage="Customer Name"*!/*/}
                {/*/!*description=""/>*!/*/}
                {/*/!*</div>*!/*/}
                {/*/!*<div className="col-md-2 ">*!/*/}
                {/*/!*<FormattedMessage id="app.admin.all.order.table.shipping-method"*!/*/}
                {/*/!*defaultMessage="Shipping Method"*!/*/}
                {/*/!*description=""/>*!/*/}
                {/*/!*</div>*!/*/}
                {/*/!*<div className="col-md-2 no-padding-left no-margin">*/}
                {/*<FormattedMessage id="app.admin.all.order.table.billing.address"*/}
                {/*defaultMessage="Billing Address"*/}
                {/*description=""/>*/}
                {/*</div>*!/*/}
                {/*<div className="col-md-3 custom-col-3">*/}

                {/*お届け先住所・名前*/}

                {/*</div>*/}
                {/*<div className="col-md-1 custom-col-1 text-right" id="order-cost-header-div">*/}
                {/*<label>*/}
                {/*<FormattedMessage id="app.admin.all.order.table.order-cost"*/}
                {/*defaultMessage="Order Cost"*/}
                {/*description=""/>($)*/}
                {/*</label>*/}
                {/*</div>*/}
                {/*<div className="col-md-1 custom-col-1 text-right" id="order-tot-header-div">*/}
                {/*<FormattedMessage id="app.admin.all.order.table.order-total"*/}
                {/*defaultMessage="Order Total"*/}
                {/*description=""/>(¥)*/}
                {/*</div>*/}
                {/*<div className="col-md-1 custom-col-1">*/}
                {/*<div className="order-status-column">*/}
                {/*/!*<FormattedMessage id="app.admin.all.order.table.status"*!/*/}
                {/*/!*defaultMessage="Status"*!/*/}
                {/*/!*description=""/>*!/*/}
                {/*進捗*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*<div className="col-md-2 custom-col-2 all-order-center-align">*/}
                {/*<FormattedMessage id="app.admin.all.order.table.action"*/}
                {/*defaultMessage="Actions"*/}
                {/*description=""/>*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*</div>*/}
            </div>
        )

    }
}

export default SalesTableHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewAllSales/SalesTableHeader/SalesTableHeader.js